import{asChildPropDef as e}from"../props/as-child.prop.js";const s=["div","span"],o=["none","inline","inline-block","block","contents"],p={as:{type:"enum",values:s,default:"div"},...e,display:{type:"enum",className:"rt-r-display",values:o,responsive:!0}};export{p as boxPropDefs};
//# sourceMappingURL=box.props.js.map
